import React from 'react'
import { Link } from 'react-router-dom'

const Minning = () => {
  return (
    <div className='flex flex-col lg:pt-[7%] pt-[9%] bg-[#161616] gap-6 lg:px-[8%] px-[4%] lg:pb-8 pb-4 relative'>
      <div className='absolute lg:block hidden w-[400px] h-[400px] left-[-100px] top-[-200px] bg-blue-400 bg-opacity-30 rounded-full blur-3xl'></div>
      <div className='absolute w-[400px] lg:block hidden h-[400px] right-[-240px] bottom-[-200px] bg-blue-400 bg-opacity-30 rounded-full blur-3xl'></div>
      <div data-aos="fade-down" className='flex w-full items-center justify-center relative'>
        <p className='text-[100px] z-[100] lg:block hidden top-[-70px] left-[24%] absolute text-white font-bold text-opacity-5'>BEST PRODUCT</p>
        <div className='lg:w-[50%] gap-4 w-full flex flex-col relative items-center justify-center'>
          <p className='lg:text-[55px] text-[30px] text-white font-semibold z-[500]'>Elite Mining  <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
            Rigs
          </span></p>
          <p className='text-[14px] text-[#ffffff] text-center'>Equip yourself with superior mining power to maximize efficiency and profitability in your mining operations.</p>
        </div>
      </div>
      <div className='lg:flex flex-col hidden lg:gap-6 w-full'>
        <div className='flex flex-row items-center justify-center w-full'>
          <div className='w-[50px] h-[50px] rounded-full items-center justify-center flex border-[1px] border-blue-400 text-[23px] font-bold text-white text-opacity-70'>01</div>
          <img width={500} src="/Blockfarm/Line 1.svg" alt="" />
          <div className='w-[50px] h-[50px] rounded-full items-center justify-center flex border-[1px] started border-blue-400 text-[23px] font-bold'>02</div>
          <img width={500} src="/Blockfarm/Line 1.svg" alt="" />
          <div className='w-[50px] h-[50px] rounded-full items-center justify-center flex border-[1px]  border-blue-400 text-[23px] font-bold text-white text-opacity-70'>03</div>
        </div>
      </div>
      <div>
        <div className='flex lg:flex-row flex-col items-center w-full lg:gap-9'>
          <img data-aos="fade-up-right" width={500} src="/Blockfarm/feature1.svg" alt="" />
          <div data-aos="fade-left" className='lg:w-[60%] w-full flex flex-col gap-4 lg:mt-0 mt-4'>
            <p className='lg:text-[45px] text-[25px] font-bold text-white'>Antminer L7 9050MH</p>
            <p className='flex text-white text-opacity-75 text-[14px]'>Antminer L7 Is manufactured By Bitmain And it mines the Scrypt algorithm which has a maximum hashrate of 9050MH/s with only 3425w power consumed.</p>
            <div className='flex items-center flex-row w-full'>
              <p className='lg:text-[22px] text-[15px] font-semibold text-white'>Bitmain Detail</p>
              <img src="/Blockfarm/Line 3.svg" className='lg:block hidden' width={600} alt="" />
            </div>
            <div className='grid lg:grid-cols-2 gap-4'>
              <div className='flex flex-row items-center gap-3'>
                <img src="/Blockfarm/round.svg" alt="" />
                <p className='text-white font-bold'>Megaheartz: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                  9050MH
                </span></p>
              </div>
              <div className='flex flex-row items-center gap-3'>
                <img src="/Blockfarm/round.svg" alt="" />
                <p className='text-white font-bold'>Algorithm: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                  SA345
                </span></p>
              </div>
              <div className='flex flex-row items-center gap-3'>
                <img src="/Blockfarm/round.svg" alt="" />
                <p className='text-white font-bold'>Power: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                  3457W
                </span></p>
              </div>
              <div className='flex flex-row items-center gap-3'>
                <img src="/Blockfarm/round.svg" alt="" />
                <p className='text-white font-bold'>Condition: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                  New
                </span></p>
              </div>
            </div>
            <div className='flex flex-col gap-4'>
              <div className='flex items-center flex-row w-full'>
                <p className='lg:text-[22px] text-[15px] font-semibold text-white'>Others Detail</p>
                <img className='lg:block hidden' src="/Blockfarm/Line 3.svg" width={600} alt="" />
              </div>
              <div className='grid lg:grid-cols-2 gap-4'>
                <div className='flex flex-row items-center gap-3'>
                  <img src="/Blockfarm/round.svg" alt="" />
                  <p className='text-white font-bold'>Location: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                    USA
                  </span></p>
                </div>
                <div className='flex flex-row items-center gap-3'>
                  <img src="/Blockfarm/round.svg" alt="" />
                  <p className='text-white font-bold'>Delivery Time: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                    4-5 Days
                  </span></p>
                </div>
                <div className='flex flex-row items-center gap-3'>
                  <img src="/Blockfarm/round.svg" alt="" />
                  <p className='text-white font-bold'>Price: <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                    $ 6.400,00
                  </span></p>
                </div>
              </div>
              <div className='flex justify-between gap-4 w-full z-[500]'>
                <div className='flex w-full'>
                  <Link className='w-full' to={""}>
                    <button className='started lg:w-full w-full py-3 px-[20px] rounded-xl text-white lg:text-[18px] text-[12px] flex items-center justify-center font-bold'>BUY NOW</button>
                  </Link>
                </div>
                <div className='flex w-full'>
                  <Link className='w-full' to={""}>
                    <button className='border-[1px] border-blue-400 px-[20px] text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700 w-full lg:w-full py-3 rounded-xl text-[12px] lg:text-[18px] flex items-center font-bold justify-center'>SEE MORE</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Minning